module.exports = __webpack_public_path__ + "img/table-delete-icon.ee4191b6.svg";